import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Linkedin, MapPin, Phone } from 'lucide-react';

// Shared between the public post page and the internal editor preview, so the two never drift.
// In `preview` mode the demo form is inert (no navigation away from the editor) but renders identically.
export default function BlogPostSidebar({ preview = false }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const handleDemoSignup = (e) => {
    e.preventDefault();
    if (preview) return;
    // Hand the email over in router state, never the URL, so it can't reach analytics or logs.
    navigate('/demo-request', { state: { email: email.trim() } });
  };

  return (
    <aside className="tc-blogpost-sidebar">
      <div className="tc-blogpost-cta-card">
        <h3>Ready to make hiring efficient?</h3>
        <p>Share your work email and we&rsquo;ll show you how TalentCrux cuts your time-to-hire.</p>
        <form className="tc-blogpost-cta-form" onSubmit={handleDemoSignup}>
          <input
            type="email"
            required={!preview}
            placeholder="What's your work email?"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            aria-label="Work email"
          />
          <button type="submit">Book a demo</button>
        </form>
        <div className="tc-blogpost-connect">
          <div className="tc-blogpost-connect-icons">
            <a href="https://www.linkedin.com/company/talentcrux" target="_blank" rel="noopener noreferrer" aria-label="TalentCrux on LinkedIn">
              <Linkedin size={18} />
            </a>
            <a
              href="https://www.google.com/maps/search/?api=1&query=The+Summit+Business+Park+Andheri+East+Mumbai+400093"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Our office location"
            >
              <MapPin size={18} />
            </a>
            <a href="tel:+919004887257" aria-label="Call TalentCrux">
              <Phone size={18} />
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
}
